import * as React from "react"
import { forwardRef } from "react"
import { IInputProps, Input as BaseInput } from "native-base"
import { translate, TxKeyPath } from "../../i18n"
import { presets } from "./input.presets"
import { FontStyleWrapper } from "react-native-cross-platform-text"
import { Appearance } from "react-native"
import { nativeBaseTheme } from "../../theme"

export interface InputProps extends IInputProps {
  placeholderTx?: TxKeyPath,
  colorScheme?: "light" | "dark",

  ref?: any
}

/**
 * Describe your component here
 */
export const Input = forwardRef(function Input(props: InputProps, ref: any) {
  const {
    placeholderTx,
    colorScheme = "light" || Appearance.getColorScheme(),
    style: styleOverride,
    multiline,
    numberOfLines,
    ...rest
  } = props

  const i18nPlaceholder = placeholderTx && translate(placeholderTx)

  const style = presets(colorScheme).default
  const styles = [style, styleOverride, multiline && { height: '81px' } || {}]

  const inputBaseStyle = nativeBaseTheme.components.InputBase.baseStyle({ colorMode: colorScheme })

  return (
    <FontStyleWrapper style={styles}>
      {(fontStyle) => (
        <BaseInput
          ref={ref}
          InputLeftElement={<></>}
          InputRightElement={<></>}
          {...inputBaseStyle}
          _hover={{ backgroundColor: colorScheme === "light" ? "light.100" : "dark.100" }}
          placeholder={i18nPlaceholder}
          multiline={multiline}
          numberOfLines={numberOfLines}
          textAlignVertical={multiline && "top" || undefined}
          alignItems={multiline && "flex-start" || undefined}
          {...(fontStyle as any)}
          {...rest}
        />
      )}
    </FontStyleWrapper>
  )
})
